mutation CreateContentMutation(
  $parentId: ID
  $title: String
  $spaceKey: String!
  $type: String!
  $subType: ConfluencePageSubType
  $contentSpecificCreateInput: [ContentSpecificCreateInput!]
) {
  createContentContextual(
    input: {
      parentId: $parentId
      spaceKey: $spaceKey
      title: $title
      status: CURRENT
      type: $type
      subType: $subType
      contentSpecificCreateInput: $contentSpecificCreateInput
    }
  ) {
    extensions {
      key
      value
    }
    history {
      createdBy {
        type
        displayName
        profilePicture {
          path
        }
        ... on KnownUser {
          accountId
        }
      }
      createdDate
      latest
    }
    macroRenderedOutput {
      key
    }
    operations {
      operation
      targetType
    }
    space {
      id
      key
      name
      status
      type
    }
    id
    status
    title
    type
    links {
      base
      collection
      context
      download
      editui
      self
      tinyui
      webui
    }
  }
}
